import { CSSProperties, PropsWithChildren } from 'react';
import * as S from './styles';
import RadioIcon from '@/components/atoms/RadioIcon';

export type RadioCardItemSize = 1 | 2 | 3;
export type RadioCardItemVariant = 'surface' | 'classic' | 'outline';
export type RadioCardItemState = 'default' | 'checked';
export type RadioCardItemIconPosition = 'start' | 'end';
export type RadioCardItemColor = 'accent' | 'neutral';

export type RadioCardItemProps = PropsWithChildren<{
  $size: RadioCardItemSize;
  $variant: RadioCardItemVariant;
  $state: RadioCardItemState;
  $highContrast: boolean;
  $useRadioIcon?: boolean;
  style?: CSSProperties;
  $iconPosition?: RadioCardItemIconPosition;
  $color?: RadioCardItemColor;
}>;

export default function RadioCardItem(props: RadioCardItemProps) {
  const {
    children,
    $state,
    $useRadioIcon = false,
    style,
    $size,
    $variant,
    $highContrast,
    $iconPosition,
    $color = 'accent',
  } = props;

  const radioCardItemProps = {
    $highContrast,
    $size,
    $variant,
    $state,
    $iconPosition,
    $useRadioIcon,
    $color,
  };

  return (
    <S.Container {...radioCardItemProps} style={style}>
      {$useRadioIcon ? (
        <RadioIcon
          $state={$state}
          style={{ order: $iconPosition === 'end' ? 2 : 0 }}
        />
      ) : null}
      {children}
    </S.Container>
  );
}
